<template>
    <div class="d-flex">
        <template v-for="(date, index) in packageDatesPreview">
            <div v-if="index < 3" :key="index" class="mr-2 d-flex flex-column">
                <v-chip
                    :color="!index ? 'primary' : 'indigo'"
                    :class="!index ? 'text-black-lighten-3' : 'text-black-lighten-5'"
                    label
                    size="small"
                    class="py-0"
                >
                    {{ date }}
                </v-chip>
                <span v-if="index < 1 && isAvailable" class="text-caption text-success" v-text="$t('available')" />
                <span
                    v-else-if="index < 1 && !isAvailable"
                    class="text-caption text-orange"
                    v-text="$t('on_request')"
                />
            </div>
        </template>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class TourAvailableDateLabel extends Vue {
        @Prop({required: true}) offers
        @Prop({required: true}) selectedDate
        @Prop() groupType

        get packageDatesPreview() {
            const selectedDate = this.$dateFns.format(this.selectedOffer.info.packageDate, 'dd MMM')
            return this.offers.reduce(
                (dates, offer, index) => {
                    if (
                        index <= 2 &&
                        dates.every(date => date !== this.$dateFns.format(offer.info.packageDate, 'dd MMM'))
                    ) {
                        dates.push(this.$dateFns.format(offer.info.packageDate, 'dd MMM'))
                    }

                    return dates
                },
                [selectedDate]
            )
        }

        get selectedOffer() {
            if (this.offers.length >= 2 && this.groupType === 'tourName') {
                return this.offers.find(offer => this.selectedDate === this.$dateFns.format(offer?.info.packageDate))
            } else return this.offers[0]
        }

        getSelectedOffer(entry) {
            switch (entry.type) {
                case 'ACCOMMODATION':
                    return this.getSelectedRoom(entry)
                case 'FLIGHT':
                    return entry.offers?.[0]
                case 'EVENT':
                case 'EXCURSION':
                case 'CRUISE':
                    for (const product of entry.offers) {
                        const selectedOffer = product.offers.find(({offerKey}) => offerKey === entry.selectedOfferKey)
                        if (selectedOffer) return selectedOffer
                    }
                    return entry.offers[0]?.offers?.[0]
                case 'EXTRA_SERVICE':
                case 'INSURANCE':
                case 'TRANSFER':
                    return entry.selectedOfferKey
                        ? entry.offers.find(offer => offer.offerKey === entry.selectedOfferKey)
                        : entry.offers[0]
                case 'CAR':
                    return entry.offer
                default:
                    return {}
            }
        }

        getSelectedHotel(entry) {
            if (!entry.obligatory && !entry.selectedOfferKey) return entry.offers[0]
            return hotelsRuntimeStore.findHotelByOfferKey(entry.offers, entry.selectedOfferKey)
        }

        getSelectedRoom(entry) {
            if (!entry.obligatory && !entry.selectedOfferKey) return entry.offers[0].rooms[0]

            return this.getSelectedHotel(entry).rooms.find(
                ({groupedOffers}) => groupedOffers[0].offerKey === entry.selectedOfferKey
            )
        }

        get isAvailable() {
            return this.selectedOffer.entries.every(entry => {
                return this.getSelectedOffer(entry).available
            })
        }
    }

    export default TourAvailableDateLabel
</script>

<style lang="scss" scoped>
    .v-chip:hover::before {
        opacity: 0;
    }
</style>
